import defaultTranslations from '../../../../../translation.en.json';
import type { InitOptions } from 'i18next';
import type { LocizeBackendOptions } from 'i18next-locize-backend';
import { appConfig } from 'src/lib/config';

export const i18nextConfig: InitOptions<LocizeBackendOptions> = {
    backend: {
        projectId: 'e51bcb59-5061-43ae-ac1e-5b39de0b3936',
        referenceLng: 'en',
        version: appConfig.i18nVersion,
    },
    resources: {
        en: {
            json: defaultTranslations,
        },
    },
    defaultNS: 'locize',
    fallbackNS: 'json',
    fallbackLng: 'en',
    keySeparator: '::',
    nsSeparator: false,
};
